<template lang="pug">

main

  .nav.quote-runner(style="background-color: #800000")
    .nav-wrapper
      p(style="color: #fff;") Join the local movement!
  
  search-n-filter
</template>

<script>
import adFeatured from '@/components/ad-featured.vue'
import searchNFilter from '@/components/search-n-filter'

export default {
  name: 'hello',
  data () {
    return {}
  },
  components: {
    adFeatured,
    searchNFilter
  }
}
</script>

<style scoped lang="stylus">

main
  width 100%

.videoWrapper {
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  margin-bottom: 30px;
}
.videoWrapper iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
  height: 100%;
}

.auzy-slider {
  margin: 0;
  padding: 0;
  width: 100%;
  position: relative;
  overflow: hidden;
  @media only screen and (max-width: 500px) {
    height: 200px;
  }
  ul.slides {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: table;
    position: relative;
    top: 0;
    transition: left 800ms;
    li {
      list-style-type: none;
      display: table-cell;
      img{
        width: 100vw;
        max-width: 100vw;
      }
    }
  }
  .controls{
    position: absolute;
    width: 100%;
    justify-content: space-between;
    padding: 20px;
    bottom: 0;
    display: flex;
    z-index: 5;
  }
  ul.bullets {
    width: inherit;
    padding: 0;
    margin: 0;
    text-align: center;
    text-shadow: 2px 2px 5px rgba(0,0,0,0.5);
    li {
      list-style-type: none;
      display: inline;
      color: white;
      cursor: pointer;
      padding: 0 5px;      
      font-size: 30px;      
      font-family: sans-serif;          
    }
  }  
  .prev,
  .next{
    text-decoration: none;
    color: #fff;
    font-size: 30px;
    text-shadow: 2px 2px 5px rgba(0,0,0,0.5);
  }
}

 :root {
  --page-color: #2196f3;
}
testimonial-slider{
  height: 400px !important;
}

html,
body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.cat-box {
  margin: 1em 1em;
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
}

featured-scroll {
  display: none;
}

.cat-box-low {
  height: 100%;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.cat-box-low p {
  padding: 0 1em 1em 0;
}

.tab-content {
  height: auto;
  font-size: 1.3em!important;
  padding: 1em !important;
  justify-content: center;
}

.indicator {
  background-color: #fff !important;
}

.tabs .tab a {
  color: #333 !important;
}
.quote-runner div{
    display: flex;
    height: 75px;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-family: Lobster;
    font-size: 2.5em;
}
.nav-wrapper{
  p{
    white-space: nowrap;
    font-size: xx-large;
  }
}
</style>
